<template>
  <div> 
    <div>this is article footer</div>
    <!-- <RelatedArticles :content="content"/> -->
  </div>
  
</template>
<script>
// import RelatedArticles from './RelatedArticles.vue';

export default {
  // components: {RelatedArticles},
  props: {
    content: {
      required: true
    }
  }
}
</script>